// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [shrink, setShrink] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";

  // Handle navbar shrink on scroll
  useEffect(() => {
    const handleScroll = () => setShrink(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Handle logo click → navigate or scroll to top
  const handleLogoClick = () => {
    if (isHome) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 300); // allow React Router to navigate before scrolling
    }
  };

  return (
    <nav
      className={`navbar ${shrink ? "navbar-shrink" : ""}`}
      role="navigation"
      aria-label="Main Navigation"
    >
      {/* Logo */}
      <div className="navbar-left">
        <button
          onClick={handleLogoClick}
          className="logo-button"
          aria-label="Go to home"
        >
          <img
            src="/images/logo.png"
            alt="UBR Engineering Logo"
            className="logo"
          />
        </button>
      </div>

      {/* Hamburger Icon */}
      <button
        className="hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
        aria-controls="navbar-menu"
      >
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
        <div className={`bar ${menuOpen ? "open" : ""}`}></div>
      </button>

      {/* Navigation Links */}
      <div
        className={`navbar-right ${menuOpen ? "open" : ""}`}
        id="navbar-menu"
      >
        {isHome ? (
          <>
            <ScrollLink
              to="home"
              smooth
              offset={-70}
              duration={500}
              spy
              activeClass="active"
            >
              Home
            </ScrollLink>
            <ScrollLink
              to="about"
              smooth
              offset={-70}
              duration={500}
              spy
              activeClass="active"
            >
              About Us
            </ScrollLink>
            <ScrollLink
              to="products"
              smooth
              offset={-70}
              duration={500}
              spy
              activeClass="active"
            >
              Products
            </ScrollLink>
            <ScrollLink
              to="testimonials"
              smooth
              offset={-70}
              duration={500}
              spy
              activeClass="active"
            >
              Testimonials
            </ScrollLink>
            <ScrollLink
              to="contact"
              smooth
              offset={-70}
              duration={500}
              spy
              activeClass="active"
            >
              Contact Us
            </ScrollLink>
          </>
        ) : (
          <>
            <RouterLink to="/">Home</RouterLink>
            <RouterLink to="/" state={{ scrollTo: "about" }}>
              About Us
            </RouterLink>
            <RouterLink to="/" state={{ scrollTo: "products" }}>
              Products
            </RouterLink>
            <RouterLink to="/" state={{ scrollTo: "testimonials" }}>
              Testimonials
            </RouterLink>
            <RouterLink to="/" state={{ scrollTo: "contact" }}>
              Contact Us
            </RouterLink>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
